/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Table_Col_AvailableInputs */

const vi_await_table_col_available = /** @type {(inputs: Await_Table_Col_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn hiện có`)
};

/**

* @param {Await_Table_Col_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_table_col_available = /** @type {((inputs?: Await_Table_Col_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Table_Col_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_table_col_available(inputs)
});